import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';

import { AgFrameworkComponent } from 'ag-grid-angular';
import {
  IFloatingFilter,
  IFloatingFilterParams,
  NumberFilter,
  NumberFilterModel,
} from 'ag-grid-community';

export interface EnumFloatingFilterParams extends IFloatingFilterParams {
  value: number;
  values: Array<{ value: number, label: string }>;
}

@Component({
  selector: 'spot-ag-grid-filter-enum',
  templateUrl: './ag-grid-filter-enum.component.html',
  styleUrls: ['./ag-grid-filter-enum.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgGridFilterEnumComponent implements IFloatingFilter, AgFrameworkComponent<EnumFloatingFilterParams> {

  public params: EnumFloatingFilterParams;
  public currentValue?: number;

  agInit(params: EnumFloatingFilterParams): void {
    this.params = params;
    this.currentValue = null;
  }

  valueChanged() {
    this.params.parentFilterInstance((instance) => {
      (instance as NumberFilter).onFloatingFilterChanged('equals', this.currentValue);
    });
  }

  onParentModelChanged(parentModel: NumberFilterModel): void {
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }
}
